import {
  CloseIcon,
  ExpandMoreIcon,
  IconButton,
  MoveIcon,
  RemoveIcon,
  SeparateIcon,
  SidebarIcon,
  Text,
  Tooltip,
} from '@thefarmersfront/kitchen';

import { useSmartSearchStore } from '~/store/common';

import type { TypeSmartSearchMode } from '~/types/smart-search.types';

import styles from './SmartSearchHeader.module.scss';

const SmartSearchHeader = () => {
  const mode = useSmartSearchStore((state) => state.mode);
  const { setMode, restoreFromMinibar, resetStore } = useSmartSearchStore((state) => state.actions);

  return (
    <div className={styles['header']}>
      <div className={styles['header-left']}>
        {(mode === 'floating' || mode === 'minimized') && (
          <div className={styles['drag-handle']} data-drag-handle>
            <MoveIcon size={20} color="white" />
          </div>
        )}
        <Text className={styles['header-title']} size="xlarge" weight="semi-bold" color="white">
          스마트 문의하기
        </Text>
      </div>

      <div className={styles['header-right']}>
        <HeaderActions mode={mode} setMode={setMode} restoreFromMinibar={restoreFromMinibar} resetStore={resetStore} />
      </div>
    </div>
  );
};

const HeaderActions = ({
  mode,
  setMode,
  restoreFromMinibar,
  resetStore,
}: {
  mode: TypeSmartSearchMode;
  setMode: (mode: TypeSmartSearchMode) => void;
  restoreFromMinibar: () => void;
  resetStore: () => void;
}) => {
  switch (mode) {
    case 'docked':
      return (
        <>
          <Tooltip description="최소화">
            <IconButton color="inverse" icon={<RemoveIcon />} onClick={() => setMode('minimized')} />
          </Tooltip>
          <Tooltip placement="bottom" description="창 분리">
            <IconButton color="inverse" icon={<SeparateIcon />} onClick={() => setMode('floating')} />
          </Tooltip>
          <Tooltip placement="bottom-right" description="닫기">
            <IconButton color="inverse" icon={<CloseIcon />} onClick={() => resetStore()} />
          </Tooltip>
        </>
      );
    case 'floating':
      return (
        <>
          <Tooltip description="최소화">
            <IconButton color="inverse" icon={<RemoveIcon />} onClick={() => setMode('minimized')} />
          </Tooltip>
          <Tooltip placement="bottom" description="화면 우측에 고정">
            <IconButton color="inverse" icon={<SidebarIcon />} onClick={() => setMode('docked')} />
          </Tooltip>
          <Tooltip placement="bottom-right" description="닫기">
            <IconButton color="inverse" icon={<CloseIcon />} onClick={() => resetStore()} />
          </Tooltip>
        </>
      );
    case 'minimized':
      return (
        <>
          <Tooltip portalTarget={document.body} description="확대">
            <IconButton color="inverse" icon={<ExpandMoreIcon />} onClick={restoreFromMinibar} />
          </Tooltip>
          <Tooltip portalTarget={document.body} placement="bottom-right" description="닫기">
            <IconButton color="inverse" icon={<CloseIcon />} onClick={() => resetStore()} />
          </Tooltip>
        </>
      );
    default:
      return null;
  }
};

export default SmartSearchHeader;
